import { render, staticRenderFns } from "./InformationModal.vue?vue&type=template&id=b0fecc8c&scoped=true&"
import script from "./InformationModal.vue?vue&type=script&lang=js&"
export * from "./InformationModal.vue?vue&type=script&lang=js&"
import style0 from "./InformationModal.vue?vue&type=style&index=0&id=b0fecc8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fecc8c",
  null
  
)

export default component.exports